import { render, staticRenderFns } from "./signatures-index.vue?vue&type=template&id=385d87b9&scoped=true"
import script from "./signatures-index.vue?vue&type=script&lang=js"
export * from "./signatures-index.vue?vue&type=script&lang=js"
import style0 from "./signatures-index.vue?vue&type=style&index=0&id=385d87b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385d87b9",
  null
  
)

export default component.exports